import type { AxiosInstance, AxiosRequestConfig } from "axios";
import { apiClient } from "@/api/apiClient";
import { DefaultApi, Configuration } from "@/api/hausify";
import { env } from "@/services/env.service";

type CreateHausifyApiOptions = {
  axiosInstance?: AxiosInstance;
  axiosOptions?: AxiosRequestConfig;
  bearerToken?: string;
};

/**
 * Creates a DefaultApi instance wired to the shared axios configuration so
 * interceptors, auth headers, and custom param serialization stay consistent.
 */
export const createHausifyApi = (
  options: CreateHausifyApiOptions = {},
): DefaultApi => {
  const { axiosInstance, axiosOptions, bearerToken } = options;
  const client = axiosInstance ?? apiClient(axiosOptions, bearerToken);

  const basePathOverride = client.defaults.baseURL
    ? undefined
    : env.REACT_APP_API;

  const configuration = new Configuration({
    basePath: basePathOverride,
  });

  return new DefaultApi(configuration, undefined, client);
};
